import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DownloadHistory = ({ downloads, onRedownload }) => {
  const mockDownloads = downloads || [
    {
      id: 1,
      filename: "Yellowstone_Adventure_Detailed.pdf",
      format: "Detailed Itinerary",
      size: "4.2 MB",
      downloadDate: new Date(Date.now() - 300000), // 5 minutes ago
      status: "completed"
    },
    {
      id: 2,
      filename: "Yellowstone_Adventure_Summary.pdf",
      format: "Quick Summary",
      size: "1.8 MB",
      downloadDate: new Date(Date.now() - 900000), // 15 minutes ago
      status: "completed"
    },
    {
      id: 3,
      filename: "Yellowstone_Adventure_v1.pdf",
      format: "Detailed Itinerary",
      size: "3.9 MB",
      downloadDate: new Date(Date.now() - 1800000), // 30 minutes ago
      status: "completed"
    }
  ];

  const formatTimeAgo = (date) => {
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours} hours ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} days ago`;
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return { name: 'CheckCircle', color: 'text-success' };
      case 'processing':
        return { name: 'Clock', color: 'text-warning' };
      case 'failed':
        return { name: 'XCircle', color: 'text-error' };
      default:
        return { name: 'FileText', color: 'text-muted-foreground' };
    }
  };

  if (mockDownloads?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-organic shadow-organic">
        <div className="p-6 border-b border-border">
          <h3 className="text-lg font-heading font-heading-bold text-card-foreground">Download History</h3>
        </div>
        <div className="p-6 text-center">
          <div className="w-16 h-16 bg-muted/50 rounded-organic mx-auto mb-4 flex items-center justify-center">
            <Icon name="Download" size={24} className="text-muted-foreground" />
          </div>
          <p className="text-muted-foreground">No downloads yet</p>
          <p className="text-sm text-muted-foreground mt-1">
            Your download history will appear here
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-organic shadow-organic">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-heading font-heading-bold text-card-foreground">Download History</h3>
          <span className="text-sm text-muted-foreground">
            {mockDownloads?.length} {mockDownloads?.length === 1 ? 'download' : 'downloads'}
          </span>
        </div>
      </div>
      <div className="divide-y divide-border">
        {mockDownloads?.map((download) => {
          const statusIcon = getStatusIcon(download?.status);
          
          return (
            <div key={download?.id} className="p-4 hover:bg-muted/30 transition-organic">
              <div className="flex items-center justify-between">
                <div className="flex items-start space-x-3 flex-1">
                  <div className="w-10 h-10 bg-primary/10 rounded-organic flex items-center justify-center flex-shrink-0">
                    <Icon name="FileText" size={20} className="text-primary" />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center space-x-2">
                      <p className="font-body font-body-medium text-foreground truncate">
                        {download?.filename}
                      </p>
                      <Icon 
                        name={statusIcon?.name} 
                        size={16} 
                        className={statusIcon?.color} 
                      />
                    </div>
                    
                    <div className="flex items-center space-x-4 mt-1">
                      <span className="text-sm text-muted-foreground">
                        {download?.format}
                      </span>
                      <span className="text-sm text-muted-foreground">
                        {download?.size}
                      </span>
                      <span className="text-sm text-muted-foreground">
                        {formatTimeAgo(download?.downloadDate)}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center space-x-2 ml-4">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onRedownload && onRedownload(download?.id)}
                    iconName="Download"
                    iconPosition="left"
                  >
                    Download
                  </Button>
                  
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => {
                      // In a real app, this would show more details
                      alert(`Download details for ${download?.filename}`);
                    }}
                    iconName="MoreVertical"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="p-4 border-t border-border bg-muted/30">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">
            Downloads are stored for 30 days
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => {
              // In a real app, this would clear the history
              alert('Clear download history feature coming soon!');
            }}
            iconName="Trash2"
            iconPosition="left"
          >
            Clear History
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DownloadHistory;